import universal from 'react-universal-component';
import universalImport from 'babel-plugin-universal-import/universalImport';
import path from 'path';
import { timeout } from 'yoda-site-components/lib/lazy/lazyConstants';

export default universal(
    universalImport({
        chunkName: () => 'IrisLabelledZoneLazy',
        path: () => path.join(__dirname, './LabelledZone'),
        resolve: () => require.resolveWeak('./LabelledZone'),
        load: () =>
            Promise.all([
                import(/* webpackChunkName: "IrisLabelledZoneLazy" */ './LabelledZone'),
            ]).then((proms) => proms[0]),
    }),
    {
        loading: () => null,
        error: () => null,
        timeout,
    }
);
